import React from "react";
import Hidden from "@material-ui/core/Hidden";

import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Box, Grid, makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

export default function TopPart() {
  const useStyles = makeStyles((theme) => ({
    DuLichGanNha: {
      justifyContent: "flex-start",
      color: "white",
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
        textAlign: "center",
      },
      margin: window.innerHeight < 400 && "40px 0 0 0",
    },
    introduction: {
      fontWeight: "bold",
      color: "white",
      fontSize: "37px",
      [theme.breakpoints.down(1025)]: {
        fontSize: "28px",
      },
    },
    content: {
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },

      [theme.breakpoints.down(1025)]: {
        fontSize: "20px",
      },
    },
  }));
  const classes = useStyles();
  var h = window.innerHeight;
  return (
    <div>
      <Grid
        container
        item
        xs={12}
        md={8}
        lg={6}
        className={classes.DuLichGanNha}
      >
        <Grid xs={12} item>
          <Typography className={classes.introduction}>
            Du lịch gần nhà
          </Typography>
        </Grid>{" "}
        <Grid item>
          <Typography className={classes.content}>
            Dừng chân ở một điểm đến mới mẻ. Khám phá các chỗ ở gần bạn để thư
            giãn.
          </Typography>
        </Grid>
        <Grid xs={12} item>
          <Link style={{ textDecoration: "none" }} to={"/place"}>
            <Button
              variant="contained"
              style={{
                marginTop: "2vh",
                backgroundColor: "white",
              }}
              item
            >
              Khám phá những địa điểm gần đây
            </Button>
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}
